import styled from "styled-components";
import { fontSizes, fontWeights, lineHeights, mediaQueries, spacing, typographyMixin } from "@magicbi/ui-library";
import { Button } from "../../atoms";
import type { ButtonProps } from "../../atoms";
import type { DistributionSaveState } from "./DistributionWizardFooter.types";

/**
 * The distribution UI's buttons, thin aliases of the design-system Button so every
 * distribution screen shares them: dark ink main, purple outline, plain, link.
 */
export const PrimaryButton = styled(Button).attrs<ButtonProps>((props) => ({ variant: "dark", size: props.size ?? "md", fixedHeight: true }))``;

export const OutlineButton = styled(Button).attrs<ButtonProps>((props) => ({ variant: "outline", size: props.size ?? "md", fixedHeight: true }))``;

export const PlainButton = styled(Button).attrs<ButtonProps>((props) => ({ variant: "secondary", size: props.size ?? "md", fixedHeight: true }))``;

export const GhostButton = styled(Button).attrs<ButtonProps>((props) => ({ variant: "link", size: props.size ?? "md", fixedHeight: true }))``;

/** Content of the frame's sticky footer bar (the bar itself, its border and padding, come from SetupFrame). */
export const Footer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[3]};
  min-width: 0;
`;

/** Readiness line at the start of the bar: "Fix 2 things to activate". */
export const Status = styled.span`
  flex: 1 1 14rem;
  min-width: 0;
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["20"]};
  font-weight: ${fontWeights.medium};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Autosave = styled.span<{ $state: DistributionSaveState }>`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1]};
  ${typographyMixin("caption", 4)}
  color: ${({ $state, theme }) =>
    $state === "error" ? theme.colors.error.text : theme.colors.text.secondary};

  svg {
    width: ${spacing[3]};
    height: ${spacing[3]};
    flex: none;
  }
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: ${spacing[3]};
  margin-left: auto;

  ${mediaQueries.down.md} {
    width: 100%;
    margin-left: 0;
    justify-content: flex-end;
  }
`;

export const Message = styled.p<{ $tone: "warning" | "error" }>`
  flex: 1 1 14rem;
  min-width: 0;
  margin: 0;
  font-size: ${fontSizes["13"]};
  line-height: ${lineHeights["20"]};
  font-weight: ${fontWeights.medium};
  color: ${({ $tone, theme }) => ($tone === "error" ? theme.colors.error.text : theme.colors.text.secondary)};
`;
